import request from "./request";
const rootPath =
  process.env.NODE_ENV === "development"
    ? "/api"
    : "https://language.phenxie.com/api";
export function mocaList(pageNum, pageSize, params = {}) {
  return request({
    url:
      rootPath +
      `/examine/moca/listpage?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: "post",
    data: params,
  });
}
export function addmoca(params) {
  return request({
    url: rootPath + `/examine/moca/add`,
    method: "post",
    data: params,
  });
}
export function deletemoca(id) {
  return request({
    url: rootPath + `/examine/moca/remove?id=${id}`,
    method: "post",
    data: {},
  });
}
export function updatemoca(params) {
  return request({
    url: rootPath + `/examine/moca/update`,
    method: "post",
    data: params,
  });
}
export function getmocaDetail(id) {
  return request({
    url: rootPath + `/examine/moca/${id}`,
    method: "get",
    params: {},
  });
}
